import Layer2 from './Base';

export default function RiskDefinitions({ session }) {
  return <Layer2 page="Risk Definitions" />;
}
